/*
 * @Author: jiameng15
 * @Date: 2021-07-09 09:38:43
 * @Last Modified by: jiameng15
 * @Last Modified time: 2025-01-13 14:23:09
 * 用户相关接口
 */

import request from "@/utils/request"; // 引入request,基于axios
import queryString from "querystring"; // post方法传参转型String
/**
 * 1.图片上传
 */
export function postImgUpload(data) {
  return request({
    url: "/upload/url",
    method: "post",
    data: data,
  });
}
